import React from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { CouponDetailType } from 'types/coupon'
import { checkInvalidCampaign } from 'helpers/dine-in'
import { Fonts } from 'components/base-ui'
import {
  Wrapper,
  Image,
  Details,
  Period,
  PointsRequired,
  RedeemButtonWrapper,
  RedeemButton,
  FlexContainer,
  Info,
} from './styled'

interface CampaignItemProps {
  campaign: CouponDetailType
  memberTotalPoints: number
  onClick: (campaign: CouponDetailType) => void
}

const CampaignItem = ({ campaign, memberTotalPoints, onClick }: CampaignItemProps) => {
  const { thumbnailImageURL, name, pointsRequire, startTime, endTime } = campaign
  const { t } = useTranslation()
  const startTimeFormatted = dayjs(startTime).format('DD/MM/YY')
  const endTimeFormatted = dayjs(endTime).format('DD/MM/YY')
  const { buttonText, inActive } = checkInvalidCampaign(campaign, memberTotalPoints)

  return (
    <Wrapper onClick={() => onClick(campaign)}>
      <Image src={thumbnailImageURL} alt="campaign" />
      <Details>
        <Fonts.SmallTitleBold>{name}</Fonts.SmallTitleBold>
        <FlexContainer>
          <Info>
            <Period>
              {t('dineIn.campaign.availablePeriod', { start: startTimeFormatted, end: endTimeFormatted })}
            </Period>
            <PointsRequired inActive={inActive}>
              {t('dineIn.campaign.points', { points: pointsRequire })}
            </PointsRequired>
          </Info>
          <RedeemButtonWrapper>
            <RedeemButton xtra_sssm outline gray={inActive}>
              {buttonText}
            </RedeemButton>
          </RedeemButtonWrapper>
        </FlexContainer>
      </Details>
    </Wrapper>
  )
}

export default CampaignItem
